import React from 'react';
import ContentMessage from '../../_lib/components/ContentMessage/ContentMessage';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { FooterLink } from '../../components/molecules/FooterLink/FooterLink';
import IUrl from '../../types/IUrl';
import { DefaultView, OptionalEditView, Views } from '../../types/BlockWithViews';
import { TopHeadlineBlockEditForm, TopHeadlinesBlockEdit } from './partials/TopHeadlinesBlockEdit';
import { TopHeadline } from './TopHeadlineType';
import { TopHeadlineList } from './partials/TopHeadlineList';
import { useLoadMore } from '../../_lib/components/LoadMore/useLoadMore';
import { LoadMoreButtonType } from '../../_lib/components/LoadMore/partials/LoadMoreButton';
import { LoadMore } from '../../_lib/components/LoadMore/LoadMore';

type Embedded = {
  items: TopHeadline[];
  updateForm?: TopHeadlineBlockEditForm;
  archiveUrl?: IUrl;
  loadMore?: LoadMoreButtonType;
};
export type TopHeadlinesBlockProps = Views<DefaultView<Embedded> & OptionalEditView<Embedded>>;

export function TopHeadlines({ activeView = 'default', views }: TopHeadlinesBlockProps) {
  const { t } = useSonTranslation('TopHeadlinesForm');
  const { items: topHeadlines, archiveUrl, loadMore, updateForm } = activeView === 'edit' && views.edit
    ? views.edit.embedded
    : views.default.embedded;

  const {
    resultList,
    loadingStatus,
    loadMoreStatus,
    itemToBeFocused,
    listContainerRef,
    listItemRef,
    loadMoreItems,
  } = useLoadMore<TopHeadline>(
    loadMore,
    topHeadlines,
  );

  return (
    <>
      {updateForm ? <TopHeadlinesBlockEdit form={updateForm} /> : null}
      {(!topHeadlines || topHeadlines.length === 0) && <ContentMessage text={t('noItems')} />}
      <div className="top-headlines">
        {resultList && (
          <LoadMore
            loadMore={loadMore}
            loadMoreStatus={loadMoreStatus}
            loadMoreItems={loadMoreItems}
            loadingStatus={loadingStatus}
            ref={listContainerRef}
          >
            <TopHeadlineList
              topHeadlines={resultList as TopHeadline[]}
              isEditView={activeView === 'edit'}
              itemToBeFocused={itemToBeFocused}
              listItemRef={listItemRef}
            />
          </LoadMore>
        )}
        {archiveUrl && <FooterLink footerButtonLabel={t('toTopHeadlinesArchive')} footerLink={archiveUrl} />}
      </div>
    </>
  );
}

export const TopHeadlinesBlock = asFetchableBlock(
  TopHeadlines,
  BlockType.topheadlines,
);
